import React, { useRef } from 'react';
import './Coverage.css';
import { FiExternalLink } from 'react-icons/fi';

const Coverage = ({ title, items }) => {
  const scrollContainerRef = useRef(null);

  return (
    <section className="coverage-section">
      <div className="section-header">
        <h2>{title}</h2>
        <div className="header-line"></div>
      </div>

      <div className="coverage-carousel-container">
        
        <div className="coverage-scroller" ref={scrollContainerRef}>
          {items.map((item, index) => (
            <div key={index} className="coverage-card" style={{ backgroundImage: `url(${item.image})` }}>
              <div className="coverage-card-overlay">
                <span className="coverage-card-title">{item.title}</span>
                <a href={item.link || '#'} className="external-link-icon" aria-label={`Explore ${item.title}`}>
                  <FiExternalLink />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Coverage;